import { css } from '@emotion/react';

type Props = {
  children?: React.ReactNode[] | React.ReactNode;
  className?: string;
  avoidHeader?: boolean;
  maxWidth?: number;
};

const Content = ({ children, className, maxWidth = 1200, ...rest }: Props) => {
  return (
    <div
      className={className}
      css={css`
        box-sizing: border-box;
        max-width: ${maxWidth}px;
        margin: 0 auto;
        width: 100%;
      `}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Content;
